import { colors } from '../constants';
import { SHADOW_LEVEL3, SHADOW_LEVEL1 } from '../shadows';
const styleOverrides = {
  tooltip: ({
    theme
  }) => ({
    backgroundColor: colors.commonColors.white,
    color: colors.text.primary,
    boxShadow: SHADOW_LEVEL3,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 'normal',
    maxWidth: 330,
    textAlign: 'center',
    padding: 15,
    borderRadius: 10
  }),
  arrow: {
    color: colors.commonColors.white,
    '&:before': {
      boxShadow: SHADOW_LEVEL1
    }
  }
};
const defaultProps = {
  arrow: true
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiTooltip.js.map